import Navbar from "./components/NavBar/navbar";
import Intro from './components/Intro/intro';
import Skills from "./components/Skills/skills";
import Works from "./components/Works/works";
import Contact from "./components/Contact/contact";
import Footer from "./components/Footer/footer";
import { useEffect } from 'react';

import Lenis from '@studio-freight/lenis';

function App() {

    useEffect(() => {
        const lenis = new Lenis();

        function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
        }

        requestAnimationFrame(raf);
        
        return () => {
            lenis.destroy();
        };
    }, []);
  
    return (
        <div className="App">
            <Navbar />
            <Intro />
            <Skills />
            <Works />
            <Contact />
            <Footer />
        </div>
    );
}

export default App;
